import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';

const LoadingAlert = props => {
  return (
    <div className="alert alert-secondary text-center" role="alert">
      <FontAwesomeIcon icon={faSpinner} spin /> {props.message}
    </div>
  );
};

LoadingAlert.propTypes = {
  message: PropTypes.string
};

LoadingAlert.defaultProps = {
  message: 'Loading...'
};

export default LoadingAlert;



// WEBPACK FOOTER //
// ./src/modules/misc/components/LoadingAlert.js